import React from 'react';
import { Form, Input, Button, Card, Switch, message } from 'antd';
import { useCreateUser } from '../../hooks/userHooks'; // Ensure path is correct

const CreateUserForm = ({ onSuccess }) => {
  const [form] = Form.useForm();
  const { handleCreate, isSubmitting, error } = useCreateUser();
  
  const onFinish = async (values) => {
    try {
      const result = await handleCreate(values);
      message.success('User created successfully!');
     
      // Call the onSuccess callback if provided
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }
    } catch (err) {
      console.error('Error creating user:', err);
      message.error('Failed to create user. Please try again.');
    }
  };

  return (
    <Card title="Create User" bordered={false}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please input the name!' }]}
        >
          <Input placeholder="Enter name" />
        </Form.Item>
        
        <Form.Item
          name="email"
          label="Email"
          rules={[{ required: true, type: 'email', message: 'Please input a valid email!' }]}
        >
          <Input placeholder="Enter email" />
        </Form.Item>
        
        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: 'Please input password!' }]}
        >
          <Input.Password placeholder="Enter password" />
        </Form.Item>

        
        
        <Form.Item>
          <Button 
            type="primary" 
            htmlType="submit" 
            loading={isSubmitting}
            block
          >
            Create User
          </Button>
        </Form.Item>
        
        {error && <p style={{ color: 'red' }}>Error: {error}</p>}
      </Form>
    </Card>
  );
};

export default CreateUserForm;